import { forwardRef } from '@chakra-ui/system';

import { type IconButtonProps, IconButton } from '@frontend/legacy-components';

export type TagActionProps = Omit<IconButtonProps, 'size'> & {
  intent: 'default' | 'destructive';
};

export const TagAction = forwardRef<TagActionProps, 'button'>(
  ({ intent, ...restProps }, ref) => {
    const isDestructive = intent === 'destructive';
    const defaultColorScheme: IconButtonProps['colorScheme'] = isDestructive
      ? 'destructive'
      : 'default';

    return (
      <IconButton
        ref={ref}
        data-sub-action-type={isDestructive ? 'destructive' : 'default'}
        colorScheme={defaultColorScheme}
        isIconColorReactive
        {...restProps}
      />
    );
  },
);
